import { render, staticRenderFns } from "./SingleMessageDialog.vue?vue&type=template&id=4f2a31d4&scoped=true&"
import script from "./SingleMessageDialog.vue?vue&type=script&lang=js&"
export * from "./SingleMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=4f2a31d4&scoped=true&lang=css&"
import style1 from "./SingleMessageDialog.vue?vue&type=style&index=1&id=4f2a31d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a31d4",
  null
  
)

export default component.exports